<template>
  <div>
    <b-modal id="modalEditEditProfileSetting" ref="modalEditEditProfileSetting"
      :title="$t('Edit profile setting')" hide-footer @shown="modalShown">
      <div  v-if="editItem">
        <b-form-group label-align="right" v-if="editItem.id != 0" disabled label="ID :" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.id" disabled/>
        </b-form-group>
        <b-form-group label-align="right" :disabled="editItem.id != 0" :label="$t('Group')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select v-model="editItem.group_id" :options="groups" :disabled="editItem.id != 0"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Active')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-checkbox switch size="lg" v-model="editItem.is_enabled" value="1" unchecked-value="0" />
        </b-form-group>
        <b-card :title="$t('Available fields')">
          <b-form-group label-align="right" :label="$t('Password')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-checkbox switch size="lg" v-model.number="isPasswordAvailable" value="1" unchecked-value="0" />
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-checkbox switch size="lg" v-model.number="isNameAvailable" value="1" unchecked-value="0" />
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Email')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-checkbox switch size="lg" v-model.number="isEmailAvailable" value="1" unchecked-value="0" />
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Telephone')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-checkbox switch size="lg" v-model.number="isTelephoneAvailable" value="1" unchecked-value="0" />
          </b-form-group>
        </b-card>

        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditEditProfileSetting')" size="md"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  data () {
    return {
      isPasswordAvailable: 0,
      isNameAvailable: 0,
      isEmailAvailable: 0,
      isTelephoneAvailable: 0
    }
  },
  methods: {
    save () {
      let tmp = JSON.parse(JSON.stringify(this.editItem))
      let availableFields = 0
      availableFields += this.isPasswordAvailable
      availableFields += this.isNameAvailable * 2
      availableFields += this.isEmailAvailable * 4
      availableFields += this.isTelephoneAvailable * 8
      tmp.available_fields = availableFields
      if (!tmp.available_fields) {
        tmp.is_enabled = 0
      }
      let response = this.editItem.id !== 0
        ? this.$store.dispatch('Settings/UPDATE_EDIT_PROFILE', tmp)
        : this.$store.dispatch('Settings/CREATE_EDIT_PROFILE', tmp)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_EDIT_PROFILE')
          this.$refs.modalEditEditProfileSetting.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    modalShown () {
      let availableFields = JSON.parse(JSON.stringify(this.editItem.available_fields))
      this.isPasswordAvailable = availableFields & 1 ? 1 : 0
      this.isNameAvailable = availableFields & 2 ? 1 : 0
      this.isEmailAvailable = availableFields & 4 ? 1 : 0
      this.isTelephoneAvailable = availableFields & 8 ? 1 : 0
    }
  },
  computed: {
    groups () {
      let res = []
      for (let el of this.$store.getters['Users/GROUPS']) {
        let newEl = {}
        newEl.value = el.group_id
        newEl.text = el.group_name
        res.push(newEl)
      }
      res.push({value: 0, text: this.$t('All')})
      return res
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/customerPortal/editProfile/editModal.vue